module.exports = "/images/colect.svg?71e231dc41777a1ad3a7e64cd666ed40";